<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout row>
      <v-flex>
        <v-dialog v-model="horseDialog">
          <v-card>
            <iframe style="width:100%;height:90vh" :src="hkjcHorsePageSrc"></iframe>
          </v-card>
        </v-dialog>
        <v-combobox xs10 v-model="selectedOldRaceDate" :items="raceList" label="選擇過往場次"></v-combobox>
        <v-btn xs2 color="info" @click="loadOldResult">Go</v-btn>
        <v-btn xs2 color="warning" @click="loadLatestResult">Latest</v-btn>
        <material-card class="card-tabs racingSchedule" color="#4A8CC1">
          <v-flex>
            <v-tabs v-model="tabs" color="transparent" slider-color="white">
              <span class="subheading font-weight-light mr-3" style="align-self: center">場次 :</span>
              <v-tab class="mr-3" v-for="n in totalRaceCount" :key="n">
                <v-icon class="mr-2">mdi-calendar-blank</v-icon>
                第{{n}}場
              </v-tab>
            </v-tabs>
          </v-flex>
          <h3>{{formattedRaceInfo[tabs]!=null?formattedRaceInfo[tabs].全部資訊:''}}</h3>
        </material-card>
        <v-snackbar
          :color="betResultSnackBarColor"
          :right="true"
          v-model="betResultSnackBar"
          dark
          :timeout="5000"
        >
          <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
          <div>{{betResultSnackBarText}}</div>
          <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
        </v-snackbar>

        <v-snackbar
          color="warning"
          :right="true"
          v-model="betNotificationSnackBar"
          dark
          :timeout="5000"
        >
          <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
          <div>{{betNotificationSnackBarText}}</div>
          <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
        </v-snackbar>

        <v-dialog v-model="nameDialog" width="500" :persistent="true">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>請輸入閣下大名</v-card-title>

            <v-card-text>
              <v-text-field
                v-model="uid"
                label="Name"
                required
                autofocus
                v-on:keyup.enter="saveName()"
              ></v-text-field>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="saveName()" :disabled="isNameDialogInvalid">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="betDialog" width="500" :persistent="true">
          <confirm-bet
            :uid="uid"
            :bettingRace="bettingRace"
            :bettingHorse="bettingHorse"
            :betDialogType="betDialogType"
            :callback="betDialogConfirmCallback"
            v-on:cancel-clicked="betDialog = false"
          ></confirm-bet>
        </v-dialog>

        <material-card
          class="card-tabs racingSchedule"
          color="#4A8CC1"
          :title="'投注'"
          :IsHideable="true"
        >
          <v-data-table
            :headers="betRecordsHeaders"
            :items="sortedBetRecords"
            item-key="bid"
            v-bind:pagination.sync="betRecordsPagination"
          >
            <template slot="items" slot-scope="item">
              <tr>
                <!-- <td>{{item.item.bid}}</td>  -->

                <td>{{item.item.uid}}</td>

                <!-- <td>{{item.item.r_date_no}}</td> -->

                <td>{{item.item.formattedBetType}}</td>

                <td>{{numberWithCommas(item.item.amount)}}</td>

                <!-- <td>{{item.item.choice}}</td> -->
                <td>{{item.item.formattedChoice}}</td>

                <!-- <td>{{item.item.choice_detail}}</td> -->

                <td>{{item.item.bet_status}}</td>

                <td>{{numberWithCommas(item.item.bet_dividend)}}</td>

                <td>{{item.item.bet_reason}}</td>

                <td>{{item.item.formattedDate}}</td>
              </tr>
            </template>
          </v-data-table>
        </material-card>

        <material-card
          v-if="formattedRaceInfo && formattedRaceInfo.length > 0"
          class="card-tabs racingSchedule"
          color="#4A8CC1"
          :title="'排位表'"
          :IsHideable="true"
        >
          <!-- <v-flex
     slot="header">
            <v-tabs
                v-model="tabs"
                color="transparent"
                slider-color="white">
              <span class="subheading font-weight-light mr-3" style="align-self: center">場次 :</span>
              <v-tab
                  class="mr-3"
                  v-for="n in totalRaceCount"
                  :key="n">
                <v-icon
                    class="mr-2">mdi-calendar-blank</v-icon>
                第{{n}}場
              </v-tab>
            </v-tabs>
          </v-flex>-->
          <v-tabs-items v-if="formattedRaceInfo[tabs]" v-model="tabs">
            <!--<h3>比賽: {{formattedRaceInfo[tabs].比賽}}</h3>
            <h3>時間: {{formattedRaceInfo[tabs].時間}}</h3>
            -->

            <v-data-table
              :headers="formattedRaceInfoHeaders"
              :items="formattedRaceInfo[tabs].參賽馬匹"
              v-bind:pagination.sync="pagination"
              item-key="馬名"
              :expand="expand"
              hide-actions
            >
              <template slot="items" slot-scope="item" >
                <!-- <tr
                @click="item.expanded = !item.expanded">-->

                <tr>

                  <td>
                     {{item.item.檔位}}</td>
                  <td>{{item.item.馬匹編號}}</td>
                  <td>
                    <v-tooltip bottom v-if="item.item.nextEntries">
                      <v-icon slot="activator">mdi-information</v-icon>
                      <div>
                        此馬匹將於下個賽馬日出賽
                        <h6>賽事日期: {{item.item.nextEntries.賽事日期}}</h6>
                        <h6>賽事班次: {{item.item.nextEntries.detail.賽事班次}}</h6>
                        <h6>途程: {{item.item.nextEntries.detail.途程}}</h6>                        
                      </div>
                    </v-tooltip>

                    <a @click="horseDialog=true;hkjcHorsePageSrc=item.item.馬匹資料">{{item.item.馬名}}</a>
                    <a :href="item.item.馬匹資料" target="_blank">
                      <v-icon>mdi-open-in-new</v-icon>
                    </a>
                  </td>
                  <td>{{item.item.排位體重}} ({{item.item["排位體重+/-"]}})</td>
                  <td>{{item.item.負磅}}</td>
                  <td>{{item.item["總體重"]}}</td>
                  <td>{{item.item["評分"]}} ({{item.item["評分+/-"]}})</td>
                  <td>{{item.item.騎師}}</td>
                  <td>{{item.item.練馬師}}</td>
                  <td>{{item.item["6次近績"]}}</td>
                  <td :class="setOddTdClass(item.item['獨贏燈'])">
                    <!--@click="openBetDialog(item.item.馬名,item.item.馬匹編號, item.item['獨贏'],'獨贏',formattedRaceInfo[tabs].RaceId, formattedRaceInfo[tabs].場次)"-->
                    <v-btn
                      v-if="formattedRaceInfo[tabs].CanBet"
                      color="info"
                      @click=" if(updateCanBet(tabs)) openBetDialog(item.item,'獨贏',formattedRaceInfo[tabs].RaceId, formattedRaceInfo[tabs].場次)"
                    >{{item.item["獨贏"]}}</v-btn>

                    <span v-else>{{item.item["獨贏"]}}</span>
                  </td>
                  <td :class="setOddTdClass(item.item['位置燈'])">
                    <v-btn
                      v-if="formattedRaceInfo[tabs].CanBet"
                      color="warning"
                      @click=" if(updateCanBet(tabs)) openBetDialog(item.item,'位置',formattedRaceInfo[tabs].RaceId, formattedRaceInfo[tabs].場次)"
                    >{{item.item["位置"]}}</v-btn>
                    <span v-else>{{item.item["位置"]}}</span>
                  </td>
                  <!-- <td>{{item.item["獨贏/位置"]}}</td> -->
                  <td>
                      <v-container >
                    <v-layout  >
                        <v-flex >
                      <v-checkbox v-model="selectedBankerPQHorse" :value="item.item"></v-checkbox>
 </v-flex>
                        <v-flex >

                      <v-checkbox v-model="selectedLegPQHorse" :value="item.item"></v-checkbox>
                        </v-flex>
                    </v-layout>
                      </v-container>
                    <!--    <v-btn
                      color="warning"
                      v-if="formattedRaceInfo[tabs]['位置Q1'] == null "
                      @click="formattedRaceInfo[tabs]['位置Q1'] = item.item"
                    >{{item.item["位置Q1"]}}</v-btn>
                    <v-btn
                      color="info"
                      v-if="formattedRaceInfo[tabs]['位置Q1'] != item.item&&formattedRaceInfo[tabs]['位置Q1']!=null"
                      @click="if(updateCanBet(tabs)) openBetDialog(item.item,'位置Q',formattedRaceInfo[tabs].RaceId, formattedRaceInfo[tabs].場次)"
                    >{{item.item["位置Q2"]}}</v-btn>

                    -->
                  </td>
                  <td>{{item.item["騎練(冠亞季負)"]}}</td>
                  <td>{{item.item["騎練(冠%)"] == null?'0.00':item.item["騎練(冠%)"]}}%</td>
                  <td>{{item.item["騎練(冠亞季%)"] == null?'0.00':item.item["騎練(冠亞季%)"]}}%</td>
                   
                  <td> <v-btn color="success"  @click="item.expanded = !item.expanded">{{!item.expanded?"Open":"Close"}}</v-btn></td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-card flat>
                  <!-- <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular> -->

                  <v-card-text>上場表現: {{props.item.上場表現}}</v-card-text>
                </v-card>
              </template>
            </v-data-table>
          </v-tabs-items>
        </material-card>

        <v-bottom-sheet
          v-model="moreThanOnePQHorseSelected"
          :inset="true"
          :hide-overlay="true"
          :persistent="true"
        >
          <v-container style="background:#FAFAFA">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>位置Q</h3>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex style="background:#FAFAFA;margin:0" xs12>
                <!-- <h1>{{formattedSelectedPQHorse}}</h1>-->
                <div class="text-xs-center">
                  <v-chip
                    label
                    :class="setOddTdClass(item.qpOdds['著燈'])"
                    close
                    :key="item.item"
                    @input="removePQCombination(item)"
                    v-for="item in joinedPQHorses"
                  >
                    <span>{{item.map(x=>x.馬匹編號+":"+x.馬名).join(' 搭 ')}} | {{item.qpOdds!=null?item.qpOdds.賠率:''}}</span>
                  </v-chip>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex shrink>
                <span class="text-xs-center">總共 {{joinedPQHorses.length}} 注</span>
              </v-flex>
              <v-text-field xs5 v-model="qplBetReason" label="原因(選填)" required></v-text-field>

              <v-flex shrink>
                <v-btn xs2 color="error" @click="selectedLegPQHorse=[];selectedBankerPQHorse=[];">清除</v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn xs2 color="primary" @click="quinellaPlaceBet()">位置Q下注</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-bottom-sheet>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import io from "socket.io-client";
import moment from "moment";

import { debug, debuglog } from "util";
import { truncate } from "fs";

import ConfirmBet from "./ConfirmBet.vue";
export default {
  components: {
    ConfirmBet
  },
  data() {
    return {
      hkjcNextEntries: [],
      selectedOldRaceDate: null,
      raceList: [],
      hkjcHorsePageSrc: "",
      horseDialog: false,
      tabs: 0,
      myMoment: moment,
      pagination: {
        sortBy: "馬匹編號",
        descending: false,
        rowsPerPage: -1
      },
      betRecordsHeaders: [
        // {
        //    sortable: true,
        //    text: "bid",
        //    value: "bid"
        //  },
        {
          sortable: true,
          text: "uid",
          value: "uid"
        },

        // {
        //   sortable: true,
        //   text: "r_date_no",
        //   value: "r_date_no"
        // },

        {
          sortable: true,
          text: "投注種類",
          value: "formattedBetType"
        },

        {
          sortable: true,
          text: "金額",
          value: "amount"
        },

        {
          sortable: true,
          text: "choice",
          value: "formattedChoice"
        },

        // {
        //   sortable: true,
        //   text: "choice_detail",
        //   value: "choice_detail"
        // },

        {
          sortable: true,
          text: "派彩狀況",
          value: "bet_status"
        },

        {
          sortable: true,
          text: "派彩金額",
          value: "bet_dividend"
        },

        {
          sortable: true,
          text: "原因",
          value: "bet_reason"
        },

        {
          sortable: true,
          text: "落注日期",
          value: "formattedDate"
        }
      ],
      formattedRaceInfo: [],
      formattedRaceInfoHeaders: [
        {
          sortable: true,
          text: "檔位",
          value: "檔位"
        },
        {
          sortable: true,
          text: "馬匹編號",
          value: "馬匹編號"
        },
        {
          sortable: true,
          text: "馬名",
          value: "馬名"
        },
        {
          sortable: true,
          text: "排位體重",
          value: "排位體重"
        },
        {
          sortable: true,
          text: "負磅",
          value: "負磅"
        },
        {
          sortable: true,
          text: "總體重",
          value: "總體重"
        },
        {
          sortable: true,
          text: "評分",
          value: "評分"
        },
        {
          sortable: true,
          text: "騎師",
          value: "騎師"
        },
        {
          sortable: true,
          text: "練馬師",
          value: "練馬師"
        },
        {
          sortable: true,
          text: "6次近績(馬匹)",
          value: "6次近績(馬匹)"
        },
        {
          sortable: true,
          text: "獨贏",
          value: "獨贏"
        },
        {
          sortable: true,
          text: "位置",
          value: "位置"
        },
        // {
        //   sortable: true,
        //   text: "獨贏/位置",
        //   value: "獨贏/位置"
        // },
        {
          sortable: true,
          text: "位置Q",
          value: "位置Q1"
        },
        {
          sortable: true,
          text: "騎練(冠亞季負)",
          value: "騎練(冠亞季負)"
        },
        {
          sortable: true,
          text: "騎練(冠%)",
          value: "騎練(冠%)"
        },
        {
          sortable: true,
          text: "騎練(冠亞季%)",
          value: "騎練(冠亞季%)"
        },
        {          
          text: "詳細資料",
          value: "詳細資料"
        }
      ],
      betDialog: false,
      betDialogType: "",
      bettingHorse: {},
      betDialogFormValid: false,
      betDialogFormRules: [v => !isNaN(v)],
      bettingRaceId: null,
      raceDate: "",
      betResultSnackBar: false,
      betResultSnackBarColor: "success",
      betResultSnackBarText: "",
      betRecords: [],
      totalRaceCount: null,
      nameDialog: false,
      uid: "",
      betRecordsPagination: {
        rowsPerPage: 5,
        sortBy: "formattedDate"
      },
      betNotificationSnackBar: false,
      betNotificationSnackBarText: "",
      bettingRace: "",
      event: null,
      selectedBankerPQHorse: [],
      selectedLegPQHorse: [],
      joinedPQHorses: [],
      totalRaceInfo: null,
      jockeyChallengeStat: [],
      formattedTipsArr: [],
      formattedRaceInfo: [],
      totalRaceCount: null,
      raceInfo: [],
      quinellaPlaceArr: [],
      qplBetReason: "",
      expand: false
    };
  },
  methods: {
    updatePQHorse() {
      if (this.selectedLegPQHorse.length >= 2) {
        //copy the array
        var tmpLegArr = this.selectedLegPQHorse.slice();
        tmpLegArr = tmpLegArr.sort((x, y) => {
          return x.馬匹編號 - y.馬匹編號;
        });

        var result = [];

        if (this.selectedBankerPQHorse.length == 0) {
          //所有腳互串
          for (var i = 0; i - 1 < tmpLegArr.length; i++) {
            for (var j = i + 1; j < tmpLegArr.length; j++)
              result.push([tmpLegArr[i], tmpLegArr[j]]);
          }
        } else {
          //有膽
          var tmpBankerArr = this.selectedBankerPQHorse.slice();
          for (var i = 0; i < tmpBankerArr.length; i++) {
            for (var j = 0; j < tmpLegArr.length; j++) {
              if (tmpBankerArr.some(x => x.馬匹編號 == tmpLegArr[j].馬匹編號)) {
                continue;
              }
              result.push([tmpBankerArr[i], tmpLegArr[j]].sort(function(x,y){
                return x.馬匹編號-y.馬匹編號;
              }));
            }
          }
        }
        
        //Get QuinellaPlace mapping info for each horse..
        var targetQPOdds = this.quinellaPlaceArr.odds.find(
          x => x.場次 - 1 == this.tabs
        );
        
        if (targetQPOdds) {
          result.forEach(element => {
            //Put QPodds in to prop
            element.qpOdds =
              targetQPOdds["位置Q"][
                element[0].馬匹編號 + "-" + element[1].馬匹編號
              ];

            //For testing
            //element.qpOdds = { 著燈: 1, 賠率: "1.1" };
          });
        }

        //TODO sort it
        this.joinedPQHorses = result.filter(x => {
          return x.qpOdds;
        });
      } else {
        this.joinedPQHorses = [];
      }
    },
    //Call this after totalRaceInfo is loaded.
    async initRace() {
      var that = this;

      this.selectedBankerPQHorse = [];
      this.selectedLegPQHorse = [];
      this.joinedPQHorses = [];
      this.totalRaceInfo.AllRaceArray.forEach(function(x) {
        that.raceInfo[x.場次 - 1] = x;
      });
      this.totalRaceCount = this.totalRaceInfo.AllRaceArray.length;
      this.raceDate = this.totalRaceInfo["RaceDateStr"];

      this.formattedRaceInfo = [];

      //Build formatted raceInfo
      this.raceInfo.forEach(function(item, index) {
        if (
          that.formattedRaceInfo[index] == null &&
          that.raceInfo[index] != null
        ) {
          that.formattedRaceInfo[index] = {};
          that.formattedRaceInfo[index].參賽馬匹 = [];
          that.formattedRaceInfo[index].地點 = that.raceInfo[index].地點;
          that.formattedRaceInfo[index].場次 = that.raceInfo[index].場次;
          that.formattedRaceInfo[index].日期 = that.raceInfo[index].日期;
          that.formattedRaceInfo[index].星期 = that.raceInfo[index].星期;
          that.formattedRaceInfo[index].時間 = that.raceInfo[index].時間;
          that.formattedRaceInfo[index].比賽 = that.raceInfo[index].比賽;
          that.formattedRaceInfo[index].RaceId = that.raceInfo[index].RaceId;

          that.formattedRaceInfo[index].獎金 = that.raceInfo[index].獎金;
          that.formattedRaceInfo[index].評分 = that.raceInfo[index].評分;
          that.formattedRaceInfo[index].班次 = that.raceInfo[index].班次;

          that.formattedRaceInfo[index].全部資訊 =
            that.raceInfo[index].全部資訊;

          that.formattedRaceInfo[index]["位置Q1"] = null;
          that.formattedRaceInfo[index]["位置Q2"] = null;
          let tmpDateString = that.formattedRaceInfo[index].日期
            .replace("年", "/")
            .replace("月", "/")
            .replace("日", "");
          let testDateTime = new Date(
            tmpDateString + " " + that.formattedRaceInfo[index].時間
          );
          let currentDateTime = new Date();
          let canBet = testDateTime > currentDateTime;
          that.formattedRaceInfo[index].CanBet = canBet;
        }

        item.參賽馬匹.forEach(function(horse) {
          var formattedRiderName = horse.騎師.replace(/[0-9()\+\-]/g, "");
          if (!isNaN(horse["獨贏"]) && !isNaN(horse["位置"])) {
            horse["獨贏/位置"] = (horse["獨贏"] / horse["位置"]).toFixed(2);
          }
          horse["位置Q1"] = "1.0";
          horse["位置Q2"] = "2.0";
          if (that.corpArr[formattedRiderName] != null) {
            if (that.corpArr[formattedRiderName][horse.練馬師] != null) {
              var targetCorpArr =
                that.corpArr[formattedRiderName][horse.練馬師];

              //Calculate win rate / top 3 rate

              function parseArray(value) {
                value = parseInt(value);
                if (isNaN(value)) {
                  return 0;
                }
                return value;
              }
              var total = 0;
              targetCorpArr.forEach(function(x) {
                total += parseArray(x);
              });

              var winRate = parseArray(targetCorpArr[0]) / total;
              var top3Rate =
                (parseArray(targetCorpArr[0]) +
                  parseArray(targetCorpArr[1]) +
                  parseArray(targetCorpArr[2])) /
                total;
              winRate = (winRate * 100).toFixed(2);
              top3Rate = (top3Rate * 100).toFixed(2);
              var flatternArray = targetCorpArr.toString();

              horse["騎練(冠亞季負)"] = flatternArray;
              horse["騎練(冠亞季負)Arr"] = targetCorpArr;
              horse["騎練(冠%)"] = winRate;
              horse["騎練(冠亞季%)"] = top3Rate;

              let targetEntries = that.hkjcNextEntries.馬匹.find(
                x => x.馬名 == horse["馬名"]
              );
              //targetEntries = that.hkjcNextEntries.馬匹[0];

              if (targetEntries) {
                horse["nextEntries"] = {
                  賽事日期: that.hkjcNextEntries.賽事日期,
                  detail: targetEntries
                };
              }
            } else {
              horse["騎練(冠亞季負)"] = "????";
              console.log(
                `Mapping ${formattedRiderName} : ${horse.練馬師} not found.`
              );
            }
          } else {
            horse["騎練(冠亞季負)"] = "????";
            console.log("騎師 " + formattedRiderName + " not found.");
          }
          horse["排位體重+負磅"] =
            parseInt(horse["排位體重"]) + parseInt(horse["負磅"]);

          that.formattedRaceInfo[index].參賽馬匹.push(horse);
        });
      });
      let tmpBetRecords = await this.$http.get(
        "betting/betrecords/" + this.formattedRaceInfo[0].RaceId
      );
      //Use the first item of formattedRaceInfo
      this.RaceLocation = this.formattedRaceInfo[0].地點;
      this.raceDate = this.formattedRaceInfo[0].日期;

      this.betRecords = tmpBetRecords.data["rows"];
      var that = this;
      this.betRecords.forEach(function(x) {
        that.formatBetRecords(x, that.formattedRaceInfo);
      });
    },
    async loadOldResult() {
      this.$vs.loading({
        type: "sound"
      });
      //TODO Fix this
      var gg = await this.$http.get(
        "racing/latestRaceInfo/" + this.selectedOldRaceDate
      );
      this.totalRaceInfo = (await this.$http.get(
        "racing/latestRaceInfo/" + this.selectedOldRaceDate
      )).data;

      this.initRace();
      this.$vs.loading.close();
    },
    async loadLatestResult() {
      this.$vs.loading({
        type: "sound"
      });
      //TODO Fix this
      var gg = await this.$http.get("racing/latestRaceInfo");
      this.totalRaceInfo = (await this.$http.get("racing/latestRaceInfo")).data;

      this.initRace();
      this.$vs.loading.close();
    },
    countDecimals(val) {
      if (Math.floor(val.valueOf()) == val.valueOf()) {
        return 0;
      }
      return val.toString().split(".")[1].length || 0;
    },

    removePQCombination(x) {
      console.log(this.joinedPQHorses);
      let index = this.joinedPQHorses.indexOf(x);
      if (index >= 0) {
        this.joinedPQHorses.splice(index, 1);
      }
      console.log(this.joinedPQHorses);
    },
    formatBetRecords(betRecord, totalRaceInfo) {
      try {
        var g = new Date(betRecord.created_at);
        var formattedDate =
          g.getFullYear() +
          "/" +
          (g.getUTCMonth() + 1) +
          "/" +
          g.getDate() +
          " " +
          (g.getHours() < 10 ? "0" + g.getHours() : g.getHours()) +
          ":" +
          (g.getMinutes() < 10 ? "0" + g.getMinutes() : g.getMinutes());
        betRecord.formattedDate = formattedDate;

        //TODO fix the hardcode.
        if (betRecord.bet_type == "w") {
          betRecord.formattedBetType = "獨贏";
        } else if (betRecord.bet_type == "p") {
          betRecord.formattedBetType = "位置";
        } else if (betRecord.bet_type == "qpl") {
          betRecord.formattedBetType = "位置Q";
        } else {
          betRecord.formattedBetType = "未知";
        }

        //Resolve horse info
        //get TargetRace from race info.
        //This is hardcoded
        var raceId = betRecord.r_date_no;
        var targetRaceInfo = totalRaceInfo.find(function(y) {
          return y.RaceId == raceId;
        });
        if (targetRaceInfo) {
          //first
          var targetHorseNum = betRecord.choice;
          betRecord.formattedChoice = targetHorseNum
            .split("+")
            .map(x => {
              var horses = targetRaceInfo["參賽馬匹"].find(function(y) {
                return y.馬匹編號 == x;
              });
              if (horses) {
                return `${horses.馬匹編號} ${horses.馬名}`;
              }
            })
            .join(" + ");
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    async quinellaPlaceBet() {
      let betAmount = 1;
      let betReason = this.qplBetReason;
      this.qplBetReason = "";
      var bet_type = "qpl";

      const that = this;
      this.$vs.loading({
        type: "sound"
      });
      await Promise.all(
        this.joinedPQHorses.map(async x => {
          try {
            var test = x.map(y => y.馬匹編號).join("+");
            const response = await that.$http.post("/betting/betrecords", {
              //username: "hkjcls",
              username: that.uid,
              passwd: "hkjcls",
              r_date_no: that.formattedRaceInfo[that.tabs].RaceId,
              bet_reason: betReason,
              bet_type: bet_type,
              amount: betAmount,
              choice: test
            });

            console.log(response);
            if (response.data.success) {
              that.betResultSnackBarText = "下注成功! 祝你好運! ";
              that.betResultSnackBarColor = "success";
            } else {
              that.betResultSnackBarText = `下注失敗！ 原因: ${response.data.code}`;
              that.betResultSnackBarColor = "error";
            }
            //TODO check code is success or fail..
            // console.log("Bet success!");
            that.betResultSnackBarColor = "success";
            that.betResultSnackBar = true;
          } catch (error) {
            console.log("DIU!");
            that.betResultSnackBar = true;
            that.betResultSnackBarColor = "error";
            that.betResultSnackBarText = "下注失敗! ";
            console.log(error);
          }
        })
      );
      this.selectedBankerPQHorse = [];
      this.selectedLegPQHorse = [];
      this.$vs.loading.close();
      this.betDialog = false;
    },
    async betDialogConfirmCallback(betAmount, betReason) {
      //Confirmed, submit to webservice :
      //var bet_type
      //獨贏=w
      //Place = p

      //Max 10000

      if (this.countDecimals(betAmount) > 1) {
        alert("小數點不得長過1!");
        return;
      }

      if (this.betAmount > 10000) {
        alert("注碼不得超過$10,000!");
        return;
      }

      var bet_type = "";
      switch (this.betDialogType) {
        case "獨贏":
          bet_type = "w";
          break;
        case "位置":
          bet_type = "p";
          break;
      }
      const that = this;
      this.$vs.loading({
        type: "sound"
      });

      try {
        const response = await this.$http.post("/betting/betrecords", {
          //username: "hkjcls",
          username: this.uid,
          passwd: "hkjcls",
          r_date_no: this.bettingRaceId,
          bet_reason: betReason,
          bet_type: bet_type,
          amount: betAmount,
          choice: this.bettingHorse.馬匹編號
        });

        console.log(response);
        if (response.data.success) {
          that.betResultSnackBarText = "下注成功! 祝你好運! ";
          that.betResultSnackBarColor = "success";
        } else {
          that.betResultSnackBarText = `下注失敗！ 原因: ${response.data.code}`;
          that.betResultSnackBarColor = "error";
        }
        //TODO check code is success or fail..
        // console.log("Bet success!");
        that.betResultSnackBarColor = "success";
        that.betResultSnackBar = true;
      } catch (error) {
        console.log("DIU!");
        that.betResultSnackBar = true;
        that.betResultSnackBarColor = "error";
        that.betResultSnackBarText = "下注失敗! ";
        console.log(error);
      }

      this.$vs.loading.close();
      this.betDialog = false;
    },
    saveName() {
      if (this.isNameDialogInvalid) {
        return;
      }
      localStorage.setItem("uid", this.uid);
      this.nameDialog = false;
    },
    getNumber(raceName, isReverse) {
      if (!isReverse) {
        switch (raceName) {
          case "第一場":
            return 1;
          case "第二場":
            return 2;
          case "第三場":
            return 3;
          case "第四場":
            return 4;
          case "第五場":
            return 5;
          case "第六場":
            return 6;
          case "第七場":
            return 7;
          case "第八場":
            return 8;
          case "第九場":
            return 9;
          case "第十場":
            return 10;
          case "第十一場":
            return 11;
          case "第十二場":
            return 12;
          case "第十三場":
            return 13;
          case "第十四場":
            return 14;
          case "第十五場":
            return 15;
        }
      } else {
        switch (raceName) {
          case 1:
            return "第一場";
          case 2:
            return "第二場";
          case 3:
            return "第三場";
          case 4:
            return "第四場";
          case 5:
            return "第五場";
          case 6:
            return "第六場";
          case 7:
            return "第七場";
          case 8:
            return "第八場";
          case 9:
            return "第九場";
          case 10:
            return "第十場";
          case 11:
            return "第十一場";
          case 12:
            return "第十二場";
          case 13:
            return "第十三場";
          case 14:
            return "第十四場";
          case 15:
            return "第十五場";
        }
      }
    },
    moment(str) {
      return moment(str);
    },
    updateCanBet(index) {
      var raceInfo = this.formattedRaceInfo[index];
      //Check datetime
      var date = raceInfo.日期;
      var formattedDateString = date
        .match(/(\d)+/gm)
        .map(x => (x.length < 2 ? "0" + x : x))
        .join("");
      var time = raceInfo.時間;
      var formattedTime = time.replace(":", "") + "00";

      var formattedMomentString =
        formattedDateString + " " + formattedTime + "+08:00";

      var raceInfoMoment = this.moment(formattedMomentString);

      if (raceInfoMoment - this.moment() < 0) {
        alert(`第${raceInfo.場次}場已過落注時間!`);
        this.formattedRaceInfo[index].CanBet = false;
      } else {
        this.formattedRaceInfo[index].CanBet = true;
      }

      return this.formattedRaceInfo[index].CanBet;
    },
    openBetDialog: function(
      horse,
      betDialogType,
      bettingRaceId,
      bettingRace,
      test
    ) {
      // if (isNaN(odds)) {
      //   // not int
      //   alert("賠率錯誤!");
      //   return;
      // }

      this.bettingRace = this.getNumber(bettingRace, true);
      this.bettingRaceId = bettingRaceId;
      this.bettingHorse = horse;
      this.betDialogType = betDialogType;

      this.betDialog = true;
      this.doubleConfirmed = false;
      test = false;
    },
    numberWithCommas: function(x) {
      if (x != null && x && !isNaN(x)) {
        return "$" + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "";
    },
    setOddTdClass(val) {
      if (!val) {
        return;
      }
      if (val == 0) {
        return;
      }

      if (val == 1) {
        return "redOdd";
      }
      if (val == 2) {
        return "greenOdd";
      }
      if (val == 3) {
        return "brownOdd";
      }
    }
  },
  async created() {
    //register socket
    //NewBetRecords
    var that = this;
    this.socket = io(process.env.VUE_APP_BASE_API, {
      transport: ["websocket"]
    });

    this.socket.on("NewBetRecords", function(newBet) {
      console.log("New Bet!");
      console.log(newBet);

      that.formatBetRecords(newBet, that.formattedRaceInfo);
      if (newBet.r_date_no == that.formattedRaceInfo[that.tabs].RaceId) {
        that.betRecords.push(newBet);
      }
      var tmpRaceNum = newBet.r_date_no.split("_")[1];

      if (newBet.uid != that.uid) {
        that.betNotificationSnackBarText = `${newBet.uid} 剛於第${tmpRaceNum}場下了注!`;
        that.betNotificationSnackBar = true;
      }
    });

    this.socket.on("ServerMessage", function(msg) {
      console.log("ServerMessage", msg);
      that.betNotificationSnackBarText = msg;
      that.betNotificationSnackBar = true;
    });

    //TODO temporary get raceInfo
    //Syntax: /raceInfo/20190109/HV/1
    console.time("raceInfo");

    this.$vs.loading({
      type: "sound"
    });
    var tmpBetRecords;
    try {
      await Promise.all(
        [
          (this.corpArr = (await this.$http.get("racing/corp")).data),
          (this.totalRaceInfo = (await this.$http.get(
            "racing/latestRaceInfo"
          )).data),
          // (this.corpArr = (await this.$http.get(
          //   "http://localhost:8887/corp.json"
          // )).data),
          // (this.totalRaceInfo = (await this.$http.get(
          //   "http://localhost:8887/latestRaceInfo.json"
          // )).data),
          (this.raceList = (await this.$http.get(
            "racing/hkjcraceresult/hist"
          )).data.Raceday),
          (this.quinellaPlaceArr = (await this.$http.get(
            "racing/oddsinfo/qpl"
          )).data),
          (this.hkjcNextEntries = (await this.$http.get(
            "racing/hkjcnextentries"
          )).data)
          // ,
          // (raceList =  (await this.$http.get(
          //   "racing/hkjcraceresult/hist")).data.Raceday)
        ]
        //   raceInfo = Array.from(Array(12).keys()).map(key => {
        //      var res = await this.$http.get( `raceInfo/20190109/HV/${key+1}`);
        //  })
        // raceInfo = Array.from(Array(12).keys()).map(key => await this.$http.get(`raceInfo/20190109/HV/${key+1}`));
      );

      this.$vs.loading.close();

      console.timeEnd("raceInfo");

      this.initRace();

      if (!localStorage.uid) {
        this.nameDialog = true;
      } else {
        this.nameDialog = false;
        this.uid = localStorage.uid;
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.$vs.loading.close();
      this.dialog = true;
      this.DialogErrorMsg = "API爆炸";
    }
  },
  computed: {
    isNameDialogInvalid() {
      return this.uid.length <= 0;
    },
    moreThanOnePQHorseSelected() {
      return this.joinedPQHorses.length >= 1;
    },
    //Sort by betId
    sortedBetRecords() {
      return this.betRecords.sort(function(x, y) {
        return x.bid > y.bid ? -1 : 1;
      });
    }
  },
  watch: {
    tabs: async function(val) {
      this.$vs.loading({
        type: "sound"
      });
      //Clean up QuinellaPlace checkBoxes
      this.selectedBankerPQHorse = [];
      this.selectedLegPQHorse = [];
      console.log("new tab index: " + val);
      console.log("new raceId: " + this.formattedRaceInfo[val].RaceId);
      //Update Bet window:
      this.betRecords = (await this.$http.get(
        "betting/betrecords/" + this.formattedRaceInfo[val].RaceId
      )).data["rows"];
      var that = this;
      this.betRecords.forEach(function(x) {
        that.formatBetRecords(x, that.formattedRaceInfo);
      });

      this.$vs.loading.close();
    },
    selectedLegPQHorse: function(val) {
      this.updatePQHorse();
    },
    selectedBankerPQHorse: function(val) {
      this.updatePQHorse();
    }
  }
};
</script>

<style scoped>
.v-input--selection-controls{ padding-top: 10px; }
.redOdd :first-child {
  background: #c80000;
  color: white;
  padding: 5px;
}

.greenOdd :first-child {
  background: #2aa216;
  color: white;
  padding: 5px;
}

.brownOdd :first-child {
  background: #993300;
  color: white;
  padding: 5px;
}
</style>
